export default "__VITE_ASSET__C3XE9h07__"